import type { BadgeDetail } from '~kui/types/badge';

import type { AnalyticsOrigin } from '~/constants/analyticsOrigin';

import { EVENTS } from '~/constants/events';

/**
 * Badge detail has three consumers (the coach shell's `/coach/badges/<slug>` view, the
 * `/wallet/<slug>` page and Learn's public `/learn/badges/<slug>` page) and all must report the
 * same view event, so the payload lives here rather than being copied into each. `origin` tells
 * the wallet's views apart from Learn's public ones.
 *
 * `isPremium` only means the badge HAS a 3D model. Since CP-10649 the model also needs an
 * earned badge (and the viewer's animations enabled), so neither property alone measures 3D
 * exposure. Segment on both.
 */
export const useWalletBadgeViewTracking = ({ badge, awardSlug, origin }: {
  badge: Ref<BadgeDetail | null>;
  awardSlug: string;
  origin: AnalyticsOrigin;
}): void => {
  const analytics = useAnalyticsService();

  watch(badge, (b) => {
    if (b) {
      analytics.track(EVENTS.UNIFIED_WALLET_ITEM_VIEWED, {
        awardSlug,
        awardName: b.name,
        isPremium: !!b.premiumBadgeFile,
        isEarned: !!b.earned,
        origin,
      });
    }
  }, { immediate: true });
};
